 import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { ServiceEditComponent } from '../service-edit/service-edit.component';
import { ServiceSummary, ServiceService } from '../../services/service.service';
import { ServiceFilterPipe } from 'app/pipes/service-filter.pipe';
import { ServiceSearchModel } from '../service-search/service-search.component';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {

  public isLoading = false;
  public entities: any[];
  public filterName: string;
  public searchProofed: boolean;
  public searchStatus: boolean;
  public countTotalProofed: number; 
  public countTotalNotProofed: number; 

  private localStorageKey_searchProofed = "search_service_proofed";
  private localStorageKey_searchStatus = "search_service_status";

  private mostRecentServiceSearchModel: ServiceSearchModel;



  constructor(
    public dialog: MatDialog,
    private serviceSvc: ServiceService,
    private apiSvc: ApiService
  ) { }

  ngOnInit() {

    this.searchProofed = this.GetDefaultOption_SearchProofed();
    this.searchStatus = this.GetDefaultOption_SearchStatus();
 
  } 

  private getServices(model: ServiceSearchModel): void {

    this.isLoading = true;
    this.entities = [];

    this.mostRecentServiceSearchModel = model;

    this.serviceSvc.loadEntites(model).then(
      (data) => {
        this.entities = this.processResults(data);
        this.isLoading = false;
        
        this.updateStats();
      }
    );

  }

  private processResults(s: any[]) : any[] {
 
    var results =  [];
      
    s.forEach(service => {
       
      var availableSearchTerms: string[] = [];
 
      //var colors = service.VestmentColors.map(function(x) { return x.ColorText});
      //service.LiturgicalColorToolTip = "Liturgical Colors: " + colors.join(", ");
  
      // Set search terms for angular
      availableSearchTerms.push(service.Name);
      availableSearchTerms.push(service.SubName);
      availableSearchTerms.push(service.AbbreviatedName);
      availableSearchTerms.push(service.Season);
      availableSearchTerms.push(service.FeastType);
      availableSearchTerms.push(service.VestmentColors);
      availableSearchTerms.push(service.LectionarySource);
           
      service.AvailableSearchTerms = availableSearchTerms;

      results.push(service);
      //console.log(service);

    }); 

    return results;

  }

public add() {
  var modal = this.dialog.open(ServiceEditComponent);
  modal.componentInstance.NewItem();
 
  modal.afterClosed().subscribe((savedItem: ServiceSummary) => {
    this.closedModal(savedItem);
  });
}

public edit(obj: ServiceSummary) {

  var modal = this.dialog.open(ServiceEditComponent)
   modal.componentInstance.LoadItem(obj.Id);

  modal.afterClosed().subscribe((savedItem: ServiceSummary) => {
    this.closedModal(savedItem);
  });

}

public delete(obj: ServiceSummary) {

   if (confirm("Are you sure you want to delete this service?")) 
   { 
    this.isLoading = true;
    this.serviceSvc.delete(obj.Id).then(
      () => { 
        this.getServices(this.mostRecentServiceSearchModel); 
      }
    ).catch((err) => {
      alert("Could not delete the service: " + err);
      this.isLoading = false;
    });
   }

}
 

private closedModal(savedItem: ServiceSummary) {

  console.log("modal closed", savedItem);

  if (savedItem !== undefined) {
     this.getServices(this.mostRecentServiceSearchModel);
  }

}

public changeProofedOption() {
  localStorage.setItem(this.localStorageKey_searchProofed, this.searchProofed + "");
}
public changeStatusOption() {
  localStorage.setItem(this.localStorageKey_searchStatus, this.searchStatus + "");
}

private GetDefaultOption_SearchProofed() : boolean {
  var proofed = localStorage.getItem(this.localStorageKey_searchProofed);
  if (proofed === "false") {
    return false
  } else if (proofed === "true") {
    return true;
  }
  return null;
}

private GetDefaultOption_SearchStatus() : boolean {
  var proofed = localStorage.getItem(this.localStorageKey_searchStatus);
  if (proofed === "false") {
    return false
  } else if (proofed === "true") {
    return true;
  }
  return null;
}
 
public search(e: ServiceSearchModel) {
  console.log("search", e); 
  //this.getServices(e);
  this.getServices(e);
}

private updateStats() { 
  this.countTotalNotProofed = this.entities.filter(s=> s.IsProofed === false).length;
  this.countTotalProofed = this.entities.filter(s=> s.IsProofed === true).length;
}

}

